import Config from 'config';
import { fork, call, put, select } from 'redux-saga/effects';
import request from '../../../lib/request';
import waitForSession from '../../../lib/wait-for-session';
import { getUserId } from '../../session/getters';
import { selectedCostItem } from '../getters';
import {
  ON_YOUR_TICKET_SUCCESS,
  ON_YOUR_TICKET_ERROR
} from '../actions';

export function* requestAndPut(requestParameters, actionCreator) {
  const result = yield call(...requestParameters);
  yield put(actionCreator(result));
}

export const requestCostItemsActionCreator = costItems => ({
  type: ON_YOUR_TICKET_SUCCESS,
  payload: costItems ? costItems : false
});

export function requestCostItem(costItem) {
  const options = {
    credentials: 'include'
  };

  return request(`${Config.api.base}/cost_items/${costItem}`, options)
    .then(resp => resp.json());
}

export function* fetchYourTicketData() {
  yield call(waitForSession);
  const userId = yield select(getUserId);

  try {
    if (!userId) {
      throw new Error('No user - aborting');
    }

    const costItemId = yield select(selectedCostItem);

    yield fork(requestAndPut, [requestCostItem, costItemId], requestCostItemsActionCreator);
  }
  catch (e) {
    yield put({ type: ON_YOUR_TICKET_ERROR, payload: e });
  }
}



// WEBPACK FOOTER //
// ./src/modules/your-ticket/actions/sagas.js